/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Group from 'material/group/group';
import ContentType from 'material/embeds/contenttype/contenttype';
import Status from 'material/embeds/status/status';
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
import ToolTip from 'material/message/tooltip/tooltip';
import QuestionBasedContentAnalyticsCard from 'material/embeds/contentanalyticscard/questionbased/questionbased';
import StoryContentAnalyticsCard from 'material/embeds/contentanalyticscard/story/story_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/contentanalyticscard/contentanalyticscard_styles';



/* ========== ~~~~~~~~~~ CONTENT ANALYTICS CARD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ContentAnalyticsCard extends Component {
    constructor(props) {
        super(props);
        this.state = { editContentClicked: false };
    }
    renderContent = () => {
        switch (this.props.content.contentType) {
            case 'story':
                return <StoryContentAnalyticsCard content={this.props.content} contentDetail={this.getContentDetail()} />
            default:
                return <QuestionBasedContentAnalyticsCard content={this.props.content} contentDetail={this.getContentDetail()} />
        }
    };
    editContent = () => {
        this.setState({ editContentClicked: true });
        this.props.engageEditor();
        this.props.moveToContentEdit(this.props.content.contentId)
    };
    getContentDetail = () => this.props.content.contentType === "story" ? this.props.content.story : this.props.content.questionBased;
    renderTotalAnswers = () => (this.props.content.contentType !== "story" ? <div className={`total`}>
        Total Answers:  <span className={`totalnumber`}>{this.getContentDetail().totalNumberAnswered}</span> </div> : null)
    renderEditButton = () => (this.props.editPermitted ?
        <CTAs>
            <Button type={`action`}
                text={`Edit`}
                variant={`control`}
                action={this.editContent}
                name={`edit`}
                disabled={!this.props.content.contentLive || typeof this.props.content.queuePosition !== 'number'}
                operation={`load`}
                processing={this.state.editContentClicked}
            />
        </CTAs> : null)
    showText = () => this.props.content.contentLive ? 'online' : 'offline';
    render() {
        const editClicked = this.props.navigatingToEditor && !this.state.editContentClicked;
        return (
            <div className={`contentanalyticscard ${this.props.classes.contentanalyticscard} disabled-${editClicked}`}>
                <Group name={`identity`}>
                    <ContentType type={this.props.content.contentType} indicatorType={`indicator`} isLive={true} />
                    <ToolTip position={`top`} action={`mouseenter`} content={this.showText()}>
                        <div className={'status'}>
                            <Status live={this.props.content.contentLive} variant={`dot`} type={`indicator`} />
                            <span className={`text`}>{this.showText()}</span>
                        </div>
                    </ToolTip>
                </Group>
                {this.renderContent()}
                <Group name={`trailing`}>
                    {this.renderTotalAnswers()}
                    {this.renderEditButton()}
                </Group>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(ContentAnalyticsCard);
